import { useSelector, useDispatch } from 'react-redux';

import { Tooltip, PMIIcon } from '@frontend/components';

import { pmiViewTool } from 'modules/common/viewer/cadViewer/data/actions';
import {
  getIsPMIViewActive,
  getHasPMIAnnotations,
} from 'modules/common/viewer/cadViewer/data/reducer';

import ViewerButton from '../components/ViewerButton';
import ViewerButtonTooltip from '../components/ViewerButtonTooltip';

const PMIViewTool = ({ isEnabled }) => {
  const dispatch = useDispatch();
  const isPMIViewActive = useSelector(getIsPMIViewActive);
  const hasPMIAnnotations = useSelector(getHasPMIAnnotations);
  const isActive = isPMIViewActive && hasPMIAnnotations;
  return isEnabled ? (
    <Tooltip
      placement="bottom"
      label={
        hasPMIAnnotations ? (
          isPMIViewActive ? (
            <ViewerButtonTooltip firstLine="Hide PMI (Beta)" />
          ) : (
            <ViewerButtonTooltip firstLine="View PMI (Beta)" />
          )
        ) : (
          <ViewerButtonTooltip firstLine="No PMI available" />
        )
      }
      shouldWrapChildren
    >
      <ViewerButton
        isActive={isActive}
        onClick={() => dispatch(pmiViewTool.toggle())}
        disabled={!hasPMIAnnotations}
      >
        <PMIIcon boxSize={2.5} color={hasPMIAnnotations ? '#fff' : '#aaa'} />
      </ViewerButton>
    </Tooltip>
  ) : null;
};

export default PMIViewTool;
